import Image from "next/image"
import type { ComponentProps } from "react"

import { Desktop, Mobile } from "@/components/device"
import { useAppSelector } from "@/lib/hooks"
import type { Styles } from "@/types/util"

const styles = {
  mobile: {
    height: 35,
    width: "auto",
  },
  desktop: {
    height: "100%",
    width: "auto",
  },
} satisfies Styles

type Props = Omit<ComponentProps<typeof Image>, "src" | "width" | "height" | "alt">

const AppLogo = (props: Props) => {
  const configLogoUrl = useAppSelector((s) => s.configuration?.logoUrl)
  const signupCohort = useAppSelector((s) => s.signupCohort)
  const logoUrl = signupCohort?.logoUrl ?? configLogoUrl

  if (!logoUrl) return null

  return (
    <>
      <Mobile>
        <Image src={logoUrl} width={0} height={0} style={styles.mobile} alt="logo" unoptimized {...props} />
      </Mobile>
      <Desktop>
        <Image src={logoUrl} width={0} height={0} style={styles.desktop} alt="logo" unoptimized {...props} />
      </Desktop>
    </>
  )
}

export default AppLogo
